// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2022 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-select-component-container {
  /* required to set z-index */
  position: fixed;
  /* dialog overlay has a z-index of 5000 */
  z-index: 6000;
}

.theia-select-component {
  background-color: var(--theia-dropdown-background);
  cursor: pointer;
  outline: var(--theia-dropdown-border) solid 1px;
  outline-offset: -1px;
  min-height: 23px;
  min-width: 90px;
  padding: 0px 8px;
  display: flex;
  align-items: center;
  user-select: none;
  border-radius: 2px;
}

.theia-select-component .theia-select-component-label {
  width: 100%;
  color: var(--theia-dropdown-foreground);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.theia-select-component:focus {
  outline-color: var(--theia-focusBorder);
}

.theia-select-component-dropdown {
  font-family: var(--theia-ui-font-family);
  font-size: var(--theia-ui-font-size1);
  color: var(--theia-foreground);
  background-color: var(--theia-settings-dropdownBackground);
  outline: var(--theia-focusBorder) solid 1px;
  outline-offset: -1px;
  user-select: none;
  overflow: auto;
  border-radius: 2px;
}

.theia-select-component-dropdown .theia-select-component-option {
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  padding: 0px 5px;
  line-height: 22px;
}

.theia-select-component-dropdown .theia-select-component-description {
  padding: 6px 5px;
}

.theia-select-component-dropdown .theia-select-component-description:first-child {
  border-bottom: 1px solid var(--theia-editorWidget-border);
  margin-bottom: 2px;
}

.theia-select-component-dropdown .theia-select-component-description:last-child {
  border-top: 1px solid var(--theia-editorWidget-border);
  margin-top: 2px;
}

.theia-select-component-dropdown .theia-select-component-option .theia-select-component-option-value {
  width: 100%;
}

.theia-select-component-dropdown .theia-select-component-option .theia-select-component-option-detail {
  padding-left: 4px;
}

.theia-select-component-dropdown .theia-select-component-option:not(.selected) .theia-select-component-option-detail {
  color: var(--theia-textLink-foreground);
}

.theia-select-component-dropdown .theia-select-component-option.selected {
  color: var(--theia-list-activeSelectionForeground);
  cursor: pointer;
  background: var(--theia-list-activeSelectionBackground);
}

.theia-select-component-dropdown .theia-select-component-separator {
  width: 84px;
  height: 1px;
  margin: 3px 3px;
  background: var(--theia-foreground);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/select-component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,4BAA4B;EAC5B,eAAe;EACf,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,8BAA8B;EAC9B,0DAA0D;EAC1D,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,mCAAmC;AACrC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2022 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-select-component-container {\n  /* required to set z-index */\n  position: fixed;\n  /* dialog overlay has a z-index of 5000 */\n  z-index: 6000;\n}\n\n.theia-select-component {\n  background-color: var(--theia-dropdown-background);\n  cursor: pointer;\n  outline: var(--theia-dropdown-border) solid 1px;\n  outline-offset: -1px;\n  min-height: 23px;\n  min-width: 90px;\n  padding: 0px 8px;\n  display: flex;\n  align-items: center;\n  user-select: none;\n  border-radius: 2px;\n}\n\n.theia-select-component .theia-select-component-label {\n  width: 100%;\n  color: var(--theia-dropdown-foreground);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.theia-select-component:focus {\n  outline-color: var(--theia-focusBorder);\n}\n\n.theia-select-component-dropdown {\n  font-family: var(--theia-ui-font-family);\n  font-size: var(--theia-ui-font-size1);\n  color: var(--theia-foreground);\n  background-color: var(--theia-settings-dropdownBackground);\n  outline: var(--theia-focusBorder) solid 1px;\n  outline-offset: -1px;\n  user-select: none;\n  overflow: auto;\n  border-radius: 2px;\n}\n\n.theia-select-component-dropdown .theia-select-component-option {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: flex;\n  padding: 0px 5px;\n  line-height: 22px;\n}\n\n.theia-select-component-dropdown .theia-select-component-description {\n  padding: 6px 5px;\n}\n\n.theia-select-component-dropdown .theia-select-component-description:first-child {\n  border-bottom: 1px solid var(--theia-editorWidget-border);\n  margin-bottom: 2px;\n}\n\n.theia-select-component-dropdown .theia-select-component-description:last-child {\n  border-top: 1px solid var(--theia-editorWidget-border);\n  margin-top: 2px;\n}\n\n.theia-select-component-dropdown .theia-select-component-option .theia-select-component-option-value {\n  width: 100%;\n}\n\n.theia-select-component-dropdown .theia-select-component-option .theia-select-component-option-detail {\n  padding-left: 4px;\n}\n\n.theia-select-component-dropdown .theia-select-component-option:not(.selected) .theia-select-component-option-detail {\n  color: var(--theia-textLink-foreground);\n}\n\n.theia-select-component-dropdown .theia-select-component-option.selected {\n  color: var(--theia-list-activeSelectionForeground);\n  cursor: pointer;\n  background: var(--theia-list-activeSelectionBackground);\n}\n\n.theia-select-component-dropdown .theia-select-component-separator {\n  width: 84px;\n  height: 1px;\n  margin: 3px 3px;\n  background: var(--theia-foreground);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
